import React, { createContext, useContext, useState, useEffect, useCallback, useRef } from "react";
import api from "../api/axios";

const AdminContext = createContext();

export const AdminProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem("admin_token"));
  const tokenRef = useRef(token);

  useEffect(() => {
    tokenRef.current = token;
    if (token) {
      localStorage.setItem("admin_token", token);
      api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    } else {
      localStorage.removeItem("admin_token");
      delete api.defaults.headers.common["Authorization"];
    }
  }, [token]);

  const login = (newToken) => setToken(newToken);

  const logout = useCallback(() => {
    // Best-effort server-side token revocation (fire-and-forget)
    if (tokenRef.current) {
      api.post("/admin/logout").catch(() => {});
    }
    setToken(null);
  }, []);

  return <AdminContext.Provider value={{ isAdmin: !!token, login, logout }}>{children}</AdminContext.Provider>;
};

export const useAdmin = () => useContext(AdminContext);
